import React, { useContext, useEffect, useState } from 'react'

//context
import { OrgSettingsWorkspaceContext } from '@/context/OrgSettingsWorkspaceContext';
import { OrgSettingsContext } from '@/context/OrgSettings';

//interfaces
import { ITableColumn, ITableContent, ITableRows } from  '@/interfaces/simpleTable';
import { AllUsersSortByType } from  '@/interfaces/orgSettings';
import { SortBy } from  '@/interfaces/toggle';

//helpers
import { Truncate } from  '@/helpers/Text';
import { getStatus, isExternallyManaged } from  '@/helpers/OrgSettings';

//components
import UserIconAndName from  '@/components/elements/orgSettings/tableCellItems/UserIconAndName';
import UserRolePermissions from  '@/components/elements/orgSettings/tableCellItems/buttons/userRolePermissions';




const UseWorkspaceUsersScreen = () => {  
    const {appId} = useContext(OrgSettingsContext);
    const {includeArchivedUsers, setIncludeArchivedUsers, setIsLoading, userData, setSortUsersToggle, sortUsersToggle, isLoading, searchUsersString, setSearchUsersString, userDataPaginationSettings, notificationDetails, getAllUsers} = useContext(OrgSettingsWorkspaceContext);
    const [tableContent, setTableContent] = useState<ITableContent>();
    const [showFilterPanel, setShowFilterPanel] = useState<boolean>(false);
    const [showSimpleTable, setShowSimpleTable] = useState<boolean>(false);
    
    const columns: Array<ITableColumn | boolean> = [
        { title: "Username", isToggleButton: true, onSortAscendingClick: () => toggleSort(AllUsersSortByType.USERNAME, SortBy.DESCENDING), onSortDescendingClick: () => toggleSort(AllUsersSortByType.USERNAME, SortBy.ASCENDING)}, 
        { title: "First Name", isToggleButton: true, onSortAscendingClick: () => toggleSort(AllUsersSortByType.FIRST_NAME, SortBy.DESCENDING),  onSortDescendingClick: () => toggleSort(AllUsersSortByType.FIRST_NAME,  SortBy.ASCENDING)}, 
        { title: "Last Name", isToggleButton: true, onSortAscendingClick: () => toggleSort(AllUsersSortByType.LAST_NAME, SortBy.DESCENDING), onSortDescendingClick: () => toggleSort(AllUsersSortByType.LAST_NAME,  SortBy.ASCENDING)}, 
        { title: "Job Role", isToggleButton: true, onSortAscendingClick: () => toggleSort(AllUsersSortByType.JOB_ROLE, SortBy.DESCENDING),  onSortDescendingClick: () => toggleSort(AllUsersSortByType.JOB_ROLE,  SortBy.ASCENDING)}, 
        { title: "Workspace Role", isToggleButton: false}, 
        includeArchivedUsers && { title: "Status", isToggleButton: true, onSortAscendingClick: () => toggleSort(AllUsersSortByType.STATUS, SortBy.ASCENDING), onSortDescendingClick: () => toggleSort(AllUsersSortByType.STATUS, SortBy.DESCENDING) }
    ];

    const filterButtonText = includeArchivedUsers ? "Filter (1)" : "Filter";
    const filterButtonLabel ="click to view filter options";
    const searchInputLabel = "Filter user groups with search input";
    const panelTitle = "Include";
    const archivedUsersLabel = "Archived Users";
    const noDataMessage = "No user data found."
    const addNewUserButtonText = '+ Add New User';
    const addNewUserButtonLabel = 'Add a new user to the workspace';
    const bulkAddButtonText = '+ Bulk Add Users';
    const bulkAddButtonLabel = 'Add multiple users to the workspace';

    useEffect(()=> {
        if (appId){
            setIsLoading(true);
            getAllUsers();
        }
    }, [searchUsersString, sortUsersToggle, appId, includeArchivedUsers]);

    useEffect(() => {
        let rows: ITableRows[] = [];
        userData?.forEach((user) => {
            const row: ITableRows = {
                content: [
                    <UserIconAndName 
                        key={`${user.id}-pp`} 
                        profilePicture={user.profilePicUrl} 
                        userId={user.id} 
                        username={user?.userName} 
                        truncate={23} 
                        isManagedUser={isExternallyManaged(user.userManagementType)}
                        externalLoginIcon={user.provider?.iconUrl}
                    />,
                    Truncate(user.firstName ?? "", 12), 
                    Truncate(user.lastName ?? "", 12), 
                    Truncate(user.jobRole?? "", 12), 
                    <UserRolePermissions key={`${user.id}-urp`} id={user.id} permission={user.permission} grantType={user.grantType} />,
                    includeArchivedUsers && getStatus(user?.status)
                ], 
                isHighlightedRow: isExternallyManaged(user.userManagementType),
                controls: [
                    {content:"Edit User", onClick:() => onEditClick(user.id)}
                ]
            };
            rows.push(row);
        });
 
        setTableContent({rows: rows, columns: columns as ITableColumn[]});
        setShowSimpleTable(true);
        setIsLoading(false);
    }, [userData, includeArchivedUsers])

  
    function toggleSort(sortByType: AllUsersSortByType, sortBy: SortBy) {
        setSortUsersToggle([sortByType, sortBy]);
    }

    function onIncludeArchivedUserClick(){ 
        setIsLoading(true);
        setIncludeArchivedUsers(!includeArchivedUsers);
    }

    function onShowFilterPanelClick(){ 
        setShowFilterPanel(!showFilterPanel);
    }

    function onEditClick(userId:any) {
        window.location.replace(`/admin/OrganizationUser/EditProfile/${userId}`);
    }

    function setPage(pageNumber: number) {
        getAllUsers(pageNumber);
    }

    return{filterButtonText, filterButtonLabel, searchInputLabel, panelTitle, archivedUsersLabel, noDataMessage, addNewUserButtonText, addNewUserButtonLabel, isLoading, bulkAddButtonLabel, bulkAddButtonText, setSearchUsersString, searchUsersString, showSimpleTable, tableContent, setPage, includeArchivedUsers, onIncludeArchivedUserClick, onShowFilterPanelClick, showFilterPanel, userDataPaginationSettings, notificationDetails}
}

export default UseWorkspaceUsersScreen